import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getUserContextAttributes(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, attribute } = params;

    invariant(baseUrl, 'baseUrl is a required param of getUserContextAttributes()');
    invariant(brandId, 'brandId is a required param of getUserContextAttributes()');
    invariant(country, 'country is a required param of getUserContextAttributes()');
    invariant(uberToken, 'uberToken is a required param of getUserContextAttributes()');
    invariant(clientId, 'clientId is a required param of getUserContextAttributes()');
    invariant(attribute, 'attribute is a required param of getUserContextAttributes()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contextattributes/${attribute}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getUserContextAttributes');
}
